import { getURLParam } from './toolkit'

if (Pura.product?.metafields?.redirect_to_product) {
  const urlParams = new URLSearchParams(window.location.search)
  const queryString = urlParams.toString()
  const redirectUrl = queryString
    ? `${Pura.product.metafields.redirect_to_product}?${queryString}`
    : Pura.product.metafields.redirect_to_product

  window.location.href = redirectUrl
}

if (Pura.template?.name === 'login') {
  const checkoutUrl = getURLParam('checkout_url')

  if (checkoutUrl) {
    window.location.href = '/#show-account-panel'
  } else {
    setTimeout(() => {
      window.location.hash = 'show-account-panel'
    }, 500)
  }
}
